import React from "react";
import {makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import clsx from "clsx";
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import AuctionRow from "./AuctionRow";
import {AuctionType} from "constants/AuctionType";
import {AuctionStatus} from "constants/AuctionStatus";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import reduxStore from "redux/store";
import {setResource, setSaveStatusInfo, setSaveStatusError} from "redux/actions";

const useStyles = makeStyles(theme => ({
    idColumn: {
        width: 100,
    },
    userColumn: {
        width: 200,
    },
    buttonColumn: theme.components.table.buttonColumn,
    dateColumn: theme.components.table.dateColumn,
    customWidth: {
        maxWidth: 500
    }
}));

function AuctionsTable(
    {
        demandId,
        stageId,
        auctions
    }) {

    const classes = useStyles();

    const assignToAuction = (auctionId) => {
        DemandOffersAuctionService.assignToAuction(demandId, stageId, auctionId).then(resp => {
            const {resources} = reduxStore.getState();
            const auctionWrapper = resources[DemandOffersAuctionService.OFFER_AUCTIONS_LIST_DATA]
            const edit = {
                ...auctionWrapper,
                auctions: auctionWrapper.auctions.map(x => x.auctionId === resp.result.auctionId ? resp.result : x)
            }
            reduxStore.dispatch(setResource(DemandOffersAuctionService.OFFER_AUCTIONS_LIST_DATA, edit));

            if (resp.success) {
                reduxStore.dispatch(setSaveStatusInfo(Tr("auction_assign_to_auction_success")))
            } else {
                reduxStore.dispatch(setSaveStatusError(Tr("auction_assign_to_auction_error")))
            }
        });
    }

    return (<TableContainer>
        <Table className={clsx(classes.table)}>
            <TableHead>
                <TableRow>
                    <TableCell className={clsx(classes.idColumn)}>{Tr("id")}</TableCell>
                    <TableCell>{Tr("auction_name")}</TableCell>
                    <TableCell className={classes.dateColumn}>{Tr("auction_type")}</TableCell>
                    <TableCell className={classes.userColumn}>{Tr("auction_user")}</TableCell>
                    <TableCell className={classes.dateColumn}>{Tr("auction_start_date")}</TableCell>
                    <TableCell className={classes.dateColumn}>{Tr("status")}</TableCell>
                    <TableCell className={classes.buttonColumn}></TableCell>
                    <TableCell className={classes.buttonColumn}></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {auctions.map((auction) =>
                    <AuctionRow
                        classes={classes}
                        key={auction.auctionId}
                        auction={auction}
                        handleAssignToAuction={assignToAuction}
                    />
                )}
            </TableBody>
        </Table>
    </TableContainer>)
}

AuctionsTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    auctions: PropTypes.arrayOf(PropTypes.shape({
        auctionId: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        status: PropTypes.oneOf(Object.keys(AuctionStatus)).isRequired,
        type: PropTypes.oneOf(Object.keys(AuctionType)).isRequired
    })).isRequired
}

export default AuctionsTable;

